import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-g_my_on",
  "use": "icon-g_my_on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-g_my_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M674.048 637.184c100.672-56.96 171.52-170.688 171.52-295.872C845.568 151.68 696.448 0 510.08 0 323.584 0 174.464 151.68 174.464 341.312c0 128.96 67.136 238.976 171.52 295.872a456.96 456.96 0 0 0-279.68 341.312 29.824 29.824 0 0 0 7.488 30.336c3.712 11.392 14.912 15.168 26.112 15.168h820.224c11.2 0 22.4-3.84 29.824-15.168a29.824 29.824 0 0 0 7.488-30.336c-29.824-159.296-141.696-284.48-283.392-341.312z\" p-id=\"5983\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/g_my_on.svg
// module id = OluH
// module chunks = 31